import { isHostOrCoHost, mapZoomRole, type ClientRole } from '@zcs/shared';
import { withTimeout } from './promise-timeout';
import { zoomSdk } from './zoomSdk';

const SDK_CALL_TIMEOUT_MS = 10_000;

/** Prefer getUserContext role; fall back to roster row for this participantUUID. */
export async function resolveZoomRole(
  userCtx: { role?: string; participantUUID?: string; participantId?: string },
): Promise<ClientRole> {
  const fromContext = mapZoomRole(userCtx.role);
  if (isHostOrCoHost(fromContext)) return fromContext;

  const selfId = userCtx.participantUUID?.trim() || userCtx.participantId?.trim();
  if (!selfId) return fromContext === 'unknown' ? 'participant' : fromContext;

  try {
    const response = await withTimeout(
      async () => zoomSdk.getMeetingParticipants(),
      SDK_CALL_TIMEOUT_MS,
      'getMeetingParticipants',
    );
    const list =
      (response as { participants?: Array<{ participantUUID?: string; role?: string }> })
        .participants ?? [];
    const self = list.find((p) => p.participantUUID?.trim() === selfId);
    if (self?.role) {
      const fromRoster = mapZoomRole(self.role);
      if (isHostOrCoHost(fromRoster)) return fromRoster;
    }
  } catch {
    // Host/co-host only API — ignore when unavailable.
  }

  return fromContext === 'unknown' ? 'participant' : fromContext;
}
